import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecTabTheme = (theme: SenecFPPTheme) => {
    return {
        indicatorColor: theme.palette.deepBlue.main,
        styleOverrides: {
            root: {
                letterSpacing: "normal",
                fontFamily: "EnBW DIN Pro Medium, sans-serif !important",
                fontWeight: "500",
                color: `${theme.palette.neutralGray70.main} !important`,
                fontSize: "14px",
                [theme.breakpoints.up("md")]: {
                    fontSize: "16px",
                },
                minHeight: "auto",
                minWidth: "fit-content",
                marginRight: "1.5rem",
                // only apply right margin, if it is not the last tab
                ":last-of-type": {
                    marginRight: 0,
                },
                "&.MuiTab-fullWidth": {
                    marginRight: 0,
                },
                padding: "0.75rem 0.75rem calc(0.75rem - 2px) 0.75rem", // substracting the borderBottomLine
                borderRadius: 0,
                borderBottom: `2px solid ${theme.palette.neutralGray20.main}`,
                "&:hover": {
                    borderBottom: `2px solid ${theme.palette.azur50.main}`,
                    color: `${theme.palette.azur50.main} !important`,
                },
                "&.Mui-selected, &.Mui-selected:hover, &:active": {
                    borderBottom: `2px solid ${theme.palette.deepBlue.main}`,
                    color: `${theme.palette.deepBlue.main} !important`,
                },
                "&::after": {
                    // avoid double indicator in SenecTimeIntervalSelection
                    display: "none",
                },
            },
        },
    };
};
